var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGitlab1 = function SvgGitlab1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 43,
    fill: "none",
    viewBox: "0 0 39 43"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2411_171105)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6B4FBB",
    stroke: "#fff",
    strokeWidth: 1.34,
    d: "m21.036 3.046 12.161 7.04A2.81 2.81 0 0 1 34.6 12.52V26.6a2.81 2.81 0 0 1-1.403 2.436l-12.16 7.039a2.8 2.8 0 0 1-2.803 0l-12.162-7.04A2.81 2.81 0 0 1 4.67 26.6V12.52c0-1.005.535-1.934 1.402-2.436l12.162-7.039a2.8 2.8 0 0 1 2.802 0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#clip0_2411_171105)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    d: "m19.5 28.25 3.498-10.769h-6.996z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC6D26",
    d: "m19.5 28.25-3.498-10.769h-4.904z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCA326",
    d: "m11.099 17.481-1.063 3.275a.72.72 0 0 0 .263.81L19.5 28.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    d: "M11.098 17.481h4.903L13.894 11a.362.362 0 0 0-.688 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC6D26",
    d: "m19.5 28.25 3.498-10.769h4.904z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCA326",
    d: "m27.902 17.481 1.062 3.272a.72.72 0 0 1-.263.81L19.5 28.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    d: "M27.902 17.481h-4.904l2.108-6.485a.362.362 0 0 1 .688 0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2411_171105"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 10h19v19H10z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2411_171105",
    width: 38.37,
    height: 42.22,
    x: 0.45,
    y: 0.225,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.775
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.775
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2411_171105"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2411_171105",
    result: "shape"
  })))));
};
export default SvgGitlab1;